import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';

// Public endpoint'ler - token gerektirmeyen (sadece auth endpoint'leri)
const PUBLIC_ENDPOINTS = [
  '/giris',
  '/kayit',
  '/ogrenci/login', // Eski endpoint (geriye dönük uyumluluk)
  '/ogrenci/register', // Eski endpoint (geriye dönük uyumluluk)
];

// Axios instance oluştur
const apiClient = axios.create({
  baseURL: 'https://api.wexbie.com/pmyo',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - token ekle
apiClient.interceptors.request.use(
  (config) => {
    // Public endpoint kontrolü
    const isPublicEndpoint = PUBLIC_ENDPOINTS.some(endpoint => 
      config.url?.includes(endpoint)
    );

    // Public endpoint değilse token ekle
    if (!isPublicEndpoint) {
      const token = useAuthStore.getState().auth.accessToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 hatası durumunda logout
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      // Public endpoint'ler için 401 hatası durumunda token'ı resetleme
      const isPublicEndpoint = PUBLIC_ENDPOINTS.some(endpoint => 
        requestUrl.includes(endpoint)
      );
      
      if (!isPublicEndpoint) {
        // Token geçersiz veya süresi dolmuş - sadece authenticated endpoint'ler için
        useAuthStore.getState().auth.reset();
        // Login sayfasına yönlendirme - basepath ile
        if (typeof window !== 'undefined') {
          window.location.href = '/pazaryerimyo/giris-yap';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;

